/**
 * Formats a raw phone number string into (xxx) xxx-xxxx display format.
 * Mirrors the same helper in crew-app/src/helpers/formatPhone.ts.
 */
export const formatPhone = (
  value?: string | number | null,
): string | null | undefined => {
  if (value === null || value === undefined) return value
  const digits = value.toString().replace(/[^\d]/g, '')
  const len = digits.length

  if (len < 4) return digits
  if (len < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`
}
